export default __webpack_public_path__ + "static/header.customerportal-28ad9d576b1ca96d8267d790615bd8fa.jpg";